import { Component } from "../component"
import { iterable } from "../helpers/iterable"

export class Dropdown extends Component {
  constructor(props) {
    super(props)

    this.dynamicClasses = {
      open: "-open",
    }
  }

  ui() {
    return {
      toggle: ".dropdown-toggle",
      value: ".dropdown-value",
      options: ".dropdown-option",
    }
  }

  attachEvents() {
    const { toggle, value, options } = this.$ui
    const { open } = this.dynamicClasses

    toggle.addEventListener("click", () => {
      this.$el.classList.toggle(open)
    })

    iterable(options).forEach((option) => {
      option.addEventListener("click", () => {
        this.$el.classList.remove(open)
      })
    })

    document.body.addEventListener("click", (e) => {
      if (!e.target.closest(`#${this.$el.id}`)) {
        this.$el.classList.remove(open)
      }
    })
  }

  created() {
    this.attachEvents()
  }
}
